<script>
  import { createEventDispatcher, onMount, tick } from 'svelte';
  import Dialog from '../../Common/Dialog/Dialog.svelte';

  const dispatch = createEventDispatcher();

  export let open = false;
  export let isCreatingChannel = false;

  let inputEl;

  $: open && inputEl && focusInput();

  onMount(() => {
    if (inputEl) {
      inputEl.focus();
    }
  });

  const focusInput = async () => {
    await tick();
    inputEl.focus();
  };
</script>

<Dialog
  title="Ny feed"
  {open}
  placeholder="Tittel"
  on:ok={(e) => dispatch('ok', { title: e.detail, live: false, feedId: '' })}
  on:cancel={() => dispatch('cancel')}
  isLoading={isCreatingChannel}
/>

<style src="./createChannel.scss">
</style>
